import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { PAYROLL_MONTH_NOT_TRANSFERRED } from '../../models/filter.model';
import { PayrollMonthPipe } from 'src/app/pipes/payroll-month.pipe';

// After Approval tab "חודש שכר" filter. Modelled on MlmExportStatusFilterComponent (same multi-select
// checkbox look), but its options are loaded from the server (the payroll months that actually
// occur - ManipulationsToolbarStore.payrollMonths$) instead of a fixed enum, plus a trailing
// "not transferred to payroll yet" option.
@Component({
  selector: 'que-payroll-month-filter',
  imports: [CommonModule, TranslateDirective, PayrollMonthPipe],
  templateUrl: './payroll-month-filter.component.html',
  styleUrls: ['../mlm-export-status-filter/mlm-export-status-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: PayrollMonthFilterComponent, multi: true }]
})
export class PayrollMonthFilterComponent {
  readonly notTransferred = PAYROLL_MONTH_NOT_TRANSFERRED;
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  #payrollMonths$ = toSignal(this.#manipulationsToolbarStore.payrollMonths$, { initialValue: [] as number[] });
  #selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);

  options$ = computed(() => [...this.#payrollMonths$(), PAYROLL_MONTH_NOT_TRANSFERRED]);
  selected$ = computed(() => this.#selectedFilter$()?.payrollMonths ?? []);

  callBackFunction: Function = () => { };

  writeValue(obj: any): void { }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void { }

  toggleMonth(month: number) {
    const selected = this.selected$();
    const next = selected.includes(month) ? selected.filter(x => x !== month) : [...selected, month];
    // An empty selection clears the filter rather than leaving an empty array behind (which the
    // server would ignore anyway, but the filter chip would still count as "set").
    this.callBackFunction(next.length ? next : null);
  }
}
